import React from "react";
import Drawer from "../../molecules/Drawer/Drawer";
import AiChatbot from "../AiChatbot/AiChatbot";
import { useTranslation } from "react-i18next";
import AiReportDialog from "../../molecules/AiReportDialog/AiReportDialog";

interface AiAssistantDrawerProps {
  isOpen: boolean;
  widthRefElID?: string;
  withReport?: boolean;
  aiReport?: string;
  formattedReport?: string;
  hasCollapseButton?: boolean;
  sidebarItemName?: string;
  setAiReport?: (value: string) => void;
  onClose: () => void;
}

const AiAssistantDrawer = (props: AiAssistantDrawerProps) => {
  const {
    isOpen,
    onClose,
    widthRefElID = "dui-doctors-report",
    withReport = false,
    aiReport,
    formattedReport,
    hasCollapseButton = true,
    sidebarItemName,
    setAiReport,
  } = props;

  const { t } = useTranslation();

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      widthRefElID={widthRefElID}
      hasCollapseButton={hasCollapseButton}
      lightTheme={true}
    >
      {withReport ? (
        <>
          <AiReportDialog
            aiReport={aiReport}
            formattedReport={formattedReport}
            setAiReport={setAiReport}
          ></AiReportDialog>

          {aiReport !== "" ? (
            <div className="dui-ai-assistant-drawer dui-ai-assistant-drawer-with-report">
              <div className="dui-ai-assistant-title">
                {t("aiAssistant") + ` - ${sidebarItemName}`}
              </div>
              <div className="dui-ai-assistant-content">
                <AiChatbot
                  formattedReport={formattedReport}
                  sidebarItemName={sidebarItemName}
                />
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <div className="dui-ai-assistant-drawer">
          <div className="dui-ai-assistant-title">{t("aiAssistant")}</div>
          <div className="dui-ai-assistant-content">
            <AiChatbot
              formattedReport={formattedReport}
              sidebarItemName={sidebarItemName}
            />
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default AiAssistantDrawer;
